import {
  browserOriginateCapability,
  browserOriginateContractVersion,
} from "./browser-originated-call-contract";

export const browserOriginateProviderCapabilitySchemaVersion =
  "browser_originate_provider_capability.v1" as const;

export type BrowserOriginateProviderCapability = {
  schemaVersion: string | null;
  verified: boolean;
  status: string | null;
  contractVersion: string | null;
  capabilities: readonly string[];
};

export type BrowserOriginateFeatureSelection = {
  selected: boolean;
  reason:
    | "provider_unavailable"
    | "provider_unverified"
    | "provider_not_ready"
    | "schema_mismatch"
    | "contract_mismatch"
    | "capability_missing"
    | "selected";
};

/**
 * Fail-closed selection boundary for the new architecture. It cannot choose
 * the legacy callback path, and a caller must never invoke both paths for one
 * logical call after this returns false.
 */
export function selectBrowserOriginatedCallFeature(input: {
  capability: BrowserOriginateProviderCapability | null;
}): BrowserOriginateFeatureSelection {
  if (!input.capability)
    return { selected: false, reason: "provider_unavailable" };
  if (!input.capability.verified) {
    return { selected: false, reason: "provider_unverified" };
  }
  if (input.capability.status !== "ready") {
    return { selected: false, reason: "provider_not_ready" };
  }
  if (
    input.capability.schemaVersion !==
    browserOriginateProviderCapabilitySchemaVersion
  ) {
    return { selected: false, reason: "schema_mismatch" };
  }
  if (input.capability.contractVersion !== browserOriginateContractVersion) {
    return { selected: false, reason: "contract_mismatch" };
  }
  if (
    input.capability.capabilities.length !== 1 ||
    input.capability.capabilities[0] !== browserOriginateCapability
  ) {
    return { selected: false, reason: "capability_missing" };
  }
  return { selected: true, reason: "selected" };
}
